import type { IIconsVector, ITooltipProps } from 'shared/ui'
import {
  AnalyticsRoutes,
  BroadcastsRoutes,
  ChatbotRoutes,
  ContactsRoutes,
  ConversationRoutes,
  DiscoverRoutes,
} from 'entities/ExportRouters'
import { subItemsOutboundActive, subItemsMenuAIAutomationActive } from 'widgets/Menu'

export const commonTooltipProps: ITooltipProps = {
  placement: 'right',
  arrow: false,
  disableInteractive: true,
  slotProps: {
    popper: {
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, -2],
          },
        },
      ],
    },
  },
}

export type IMenuItemKeys =
  | 'conversation'
  | 'contacts'
  | 'broadcasts'
  | 'chatbot'
  | 'triggers'
  | 'analytics'
  | 'keywords'
  | 'clients'
  | 'workflows'
  | 'campaign'
  | 'powerDialer'
  | 'admin'
  | 'outbound'
  | 'AI_automation'
  | 'discover'

export type IMenuItem = {
  itemKey: IMenuItemKeys
  icon: IIconsVector
  route: string
  label: string
  isShow?: () => void
}

export type IMenuItemSidebar = IMenuItem & {
  activePaths: string[]
}

export const menuItemsV2: IMenuItemSidebar[] = [
  {
    itemKey: 'conversation',
    icon: 'inboxes',
    route: ConversationRoutes.root,
    label: 'Inboxes',
    activePaths: [ConversationRoutes.root],
  },
  {
    itemKey: 'discover',
    icon: 'compass',
    route: DiscoverRoutes.root,
    label: 'Discover',
    activePaths: [DiscoverRoutes.root],
  },
  {
    itemKey: 'AI_automation',
    icon: 'stars',
    route: ChatbotRoutes.root,
    label: 'AI & Automation',
    activePaths: subItemsMenuAIAutomationActive,
  },
  {
    itemKey: 'outbound',
    icon: 'outbound',
    route: BroadcastsRoutes.root,
    label: 'Outbound',
    activePaths: subItemsOutboundActive,
  },
  {
    itemKey: 'contacts',
    icon: 'contacts',
    route: ContactsRoutes.root,
    label: 'Contacts',
    activePaths: [ContactsRoutes.root],
  },
  {
    itemKey: 'analytics',
    icon: 'analytics',
    route: AnalyticsRoutes.root,
    label: 'Analytics',
    activePaths: [AnalyticsRoutes.root],
  },
]
